module.exports = __webpack_public_path__ + "img/coupon_tab_my.5b06d971.svg";